import { IMGs } from '../assets/img'

export const getBadges = (badge: string) => {
    switch (badge) {
        case 'Gold':
            return IMGs.BadgesGold
        case 'Silver':
            return IMGs.BadgesSilver
        case 'Platinum':
            return IMGs.BadgesPlatinum
        default:
            return IMGs.BadgesBronze
    }
}
